import { i18n } from '@/Translate'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(i18n)
})
